

export const navBackground = (background) => dispatch => {
    dispatch({
        type: 'CURRENT_BACKGROUND',
        payload: background
    });
}